import Modal from "../../layouts/Modal";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import { TemplateType } from "../../models/TemplateEditor";

export interface ITemplatePreview {
  title: string;
  type: TemplateType;
  body: string;
  isCustom: boolean;
}

interface TemplatePreviewModalProps {
  preview: ITemplatePreview | null;
  onClose: () => void;
}

// Shows the template exactly as saved, not the editor's draft: emails render as the full HTML
// document (head styles included) in a sandboxed iframe, so nothing in a template can run script
// or reach the dashboard.
export default function TemplatePreviewModal({ preview, onClose }: TemplatePreviewModalProps) {
  return (
    <Modal open={Boolean(preview)} setOpen={(open) => { if (!open) onClose(); }} width="max-w-4xl">
      {preview && (
        <div className="space-y-4">
          <div>
            <h3 className="text-lg font-medium leading-6 text-gray-900">{preview.title}</h3>
            <p className="text-sm text-gray-500">
              {preview.isCustom ? "Your saved custom template" : "Default template"} - merge tags are shown as they are stored.
            </p>
          </div>

          {preview.type === TemplateType.Message ? (
            <div className="rounded-lg border border-gray-200 bg-gray-50 p-4">
              <div className="max-w-sm rounded-2xl bg-white border border-gray-200 px-4 py-3 text-sm text-gray-900 whitespace-pre-wrap break-words shadow-sm">
                {preview.body}
              </div>
            </div>
          ) : (
            <iframe
              title={`${preview.title} preview`}
              srcDoc={preview.body}
              sandbox=""
              className="w-full h-[70vh] rounded-lg border border-gray-200 bg-white"
            />
          )}

          <div className="flex justify-end">
            <ButtonInput isSubmit={false} label="Close" onClick={onClose} classes="bg-gray-600 hover:bg-gray-700" />
          </div>
        </div>
      )}
    </Modal>
  );
}
